import React from "react";
import { useSelector } from "react-redux";
import {
    selectEnableAbandonedGifts,
    selectEnableAbandonedGiftReminderEmails,
} from "../../../redux/slices/donationSettingsSlice";
import ConnectedEmailReminderExitIntent from "./ConnectedEmailReminderExitIntent";
import ExitIntent from "./ExitIntent";

const ConnectedExitIntent = () => {
    const enableAbandonedGifts = useSelector(selectEnableAbandonedGifts);
    const enableAbandonedGiftReminderEmails = useSelector(
        selectEnableAbandonedGiftReminderEmails,
    );

    const showEmailReminderExitIntent =
        enableAbandonedGifts && enableAbandonedGiftReminderEmails;

    return showEmailReminderExitIntent ? (
        <ConnectedEmailReminderExitIntent />
    ) : (
        <ExitIntent />
    );
};

export default ConnectedExitIntent;
